import { React, PT } from '@gasbuddy/react';
import { Table } from 'semantic-ui-react';
import moment from 'moment';
import { CorrelationIdTable } from './CorrelationIdTable';

export class UserRequestTable extends React.Component {
  selectRequest = (event) => {
    const { onSelected } = this.props;
    const { id } = event.currentTarget.dataset;
    onSelected(id);
  }

  buildRows(rows, details) {
    if (!rows) {
      return null;
    }
    const domRows = [];
    rows.forEach((r) => {
      domRows.push((
        <Table.Row
          negative={r.s < 200 || r.s >= 400}
          key={r.c}
          onClick={this.selectRequest}
          data-id={r.c}
        >
          <Table.Cell>{moment(r.ts).format('MMM DD')}</Table.Cell>
          <Table.Cell>{moment(r.ts).format('HH:mm')}</Table.Cell>
          <Table.Cell>{r.label}</Table.Cell>
          <Table.Cell>
            {r.m.toUpperCase()}
            {' '}
            {r.url}
          </Table.Cell>
          <Table.Cell>{r.s}</Table.Cell>
        </Table.Row>
      ));
      if (details[r.c]) {
        domRows.push((
          <Table.Row>
            <Table.Cell colSpan={5}>
              <CorrelationIdTable logs={details[r.c].rows} />
            </Table.Cell>
          </Table.Row>
        ));
      }
    });
    return domRows;
  }

  render() {
    const { rows, details } = this.props;
    return (
      <Table selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}>Date</Table.HeaderCell>
            <Table.HeaderCell width={1}>Time</Table.HeaderCell>
            <Table.HeaderCell width={2}>Service</Table.HeaderCell>
            <Table.HeaderCell>URL</Table.HeaderCell>
            <Table.HeaderCell textAlign="center" width={1}>Status</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {this.buildRows(rows, details)}
        </Table.Body>
      </Table>
    );
  }
}

UserRequestTable.propTypes = {
  rows: PT.arrayOf(PT.shape({
    c: PT.string.isRequired,
    s: PT.number.isRequired,
    ts: PT.number.isRequired,
    label: PT.string,
    url: PT.string,
  })),
  // eslint-disable-next-line react/forbid-prop-types
  details: PT.object,
  onSelected: PT.func.isRequired,
};

UserRequestTable.defaultProps = {
  rows: [],
  details: {},
};
